/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Checkbox, Input } from 'antd';
import _ from 'lodash';
import styled from 'styled-components';
import classNames from 'classnames';

import { isValidSymbols, parser } from '../../../../event/EventFormula';
import { FORMULA_VIEWS } from '../../../../../constants/event';

const StyledEventFormulaContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 10px;

  .input-with-caption {
    margin-right: 5px;
    display: flex;
    align-items: center;
  }

  .input-caption {
    margin-right: 5px;
  }

  .input {
    margin-right: 2px;
  }
`;

const isValidFormula = (formula, events) => {
  try {
    const expr = parser.parse(formula);
    const uniqueChars = events.map((event) => event.uniqueChar);
    const dataVerification = expr.symbols().reduce((acc, elem, index) => {
      acc[elem] = index + 1;
      return acc;
    }, {});
    return (
      expr.symbols().every((r) => uniqueChars.includes(r)) &&
      // eslint-disable-next-line no-restricted-globals
      isFinite(expr.evaluate(dataVerification))
    );
  } catch (e) {
    return false;
  }
};

const EventFormula = ({
  events,
  enteredFormula,
  onChangeFormula,
  className = '',
  isFormulaOnly,
  onChangeFormulaOnly,
  unit,
}) => {
  const { view } = unit.compose.events.options;
  const isChartView = FORMULA_VIEWS.includes(view);

  const formulaInput = useRef(null);

  const [isValidInput, setValidInput] = useState(true);

  const compareSplits = (event) =>
    _.get(events, '[0].splitColumn', '') === _.get(event, 'splitColumn', '');

  const disableFormula =
    !!events.length && events.some((event) => event.splitColumn && event.othersFilter);

  const isSplitSame = !!events.length && events.every(compareSplits);

  useEffect(() => {
    if (enteredFormula === '' || !enteredFormula) {
      setValidInput(true);
      return;
    }
    const isValid =
      isValidSymbols(enteredFormula) && isValidFormula(enteredFormula.toUpperCase(), events);
    setValidInput(isValid);
  }, [events]);

  const onChange = (value) => {
    const isValid =
      (isValidSymbols(value) && isValidFormula(value.toUpperCase(), events)) || value === '';
    setValidInput(isValid);
    onChangeFormula(value.toUpperCase());
  };

  useEffect(() => {
    if (!isSplitSame || !isChartView || disableFormula) {
      onChange('');
      if (isFormulaOnly) {
        onChangeFormulaOnly();
      }
    }
  }, [isSplitSame, isChartView, disableFormula]);

  return (
    <StyledEventFormulaContainer className={className}>
      <div className="input-with-caption">
        <span className="input-caption">Formula:</span>
        <Input
          className={classNames('input', { 'not-valid': !isValidInput })}
          placeholder="Type formula"
          value={enteredFormula}
          onChange={(e) => onChange(e.target.value)}
          ref={formulaInput}
          disabled={!isSplitSame || !isChartView || disableFormula}
          maxLength={50}
        />
      </div>
      <div>
        <Checkbox
          checked={isFormulaOnly}
          disabled={!isSplitSame || !isChartView || disableFormula}
          onChange={onChangeFormulaOnly}
        >
          Only Formula
        </Checkbox>
      </div>
    </StyledEventFormulaContainer>
  );
};

export default EventFormula;
